import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'

export const TimelineDot = styled.div`
  width: 10px;
  height: 10px;
  border: 3px solid ${cssTheme.colors.border.neutral.secondary};
  border-radius: ${cssTheme.layout.radius.lg};
`
